import React from 'react';
import { Nav } from 'react-bootstrap';
import iconSeeAttachedDocs from '../../assets/icons/seeAttachedDoc.svg';
import downloadIcon from '../../assets/icons/download-attachment.svg';
import DocumentService from '../../services/Document/DocumentService';

const createDownloadElementAndClick = (fileURL, fileName) => {
    var anchorElement = window.document.createElement('a');
    anchorElement.href = fileURL;
    anchorElement.target = '_self';
    anchorElement.download = fileName;
    var event = window.document.createEvent("MouseEvents");
    event.initEvent("click", true, false);
    anchorElement.dispatchEvent(event);
};

const base64ToArrayBuffer = (data) => {
    var bString = window.atob(data);
    var bLength = bString.length;
    var bytes = new Uint8Array(bLength);
    for (var i = 0; i < bLength; i++) {
        bytes[i] = bString.charCodeAt(i);
    }
    return bytes;
};

const AttachmentNavItem = ({ docAtt, index, signerGuid, onSelect }) => {
    const handleDownload = () => {
        const fileName = docAtt.FileName.endsWith('.pdf') ? docAtt.FileName : `${docAtt.FileName}.pdf`;
        DocumentService.downloadDocumentAttachment(signerGuid, docAtt.GUID)
            .then(response => {
                const docContent = response.data.DocContent;
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    var byteCharacters = atob(docContent);
                    var byteNumbers = new Array(byteCharacters.length);
                    for (var i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    var byteArray = new Uint8Array(byteNumbers);
                    var blob = new Blob([byteArray], { type: 'application/octet-stream' });
                    window.navigator.msSaveOrOpenBlob(blob, fileName);
                } else {
                    var newBlob = new Blob([base64ToArrayBuffer(docContent)], { type: 'application/octet-stream' });
                    var fileURL = window.URL.createObjectURL(newBlob);
                    createDownloadElementAndClick(fileURL, fileName);
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    return (
        <Nav.Item className="side-tab">
            <Nav.Link
                eventKey={index}
                onClick={onSelect}
                className="nav-link-2"
            >
                <span className="side-tab-text">
                    <img src={iconSeeAttachedDocs} alt="see attached docs" className="side-tab-icons" />
                    {docAtt.FileName}
                </span>
                <img
                    src={downloadIcon}
                    alt="download attachment"
                    className="attachment-download-icon"
                    onClick={(e) => { e.stopPropagation(); handleDownload(); }}
                />
            </Nav.Link>
        </Nav.Item>
    );
};

export default AttachmentNavItem;
